import styled from "styled-components";

export const ContainerPoint = styled.div`
.custom-marker {
  width: 14px;
  height: 14px;
  background-color: white;
  border: 2px solid black;
  border-radius: 50%;
  box-shadow: 0 0 4px rgba(0,0,0,0.3);
  transform: translate(-50%, -50%);
  position: absolute;
}

.custom-marker.selected {
  background-color: lime;
}

.custom-marker.remover {
  background-color: pink;
  border-color: red;
  animation: shake 0.3s infinite;
}

@keyframes shake {
  0%, 100% { transform: translate(-50%, -50%) rotate(0deg); }
  25% { transform: translate(-50%, -50%) rotate(2deg); }
  75% { transform: translate(-50%, -50%) rotate(-2deg); }
}


`